export default __webpack_public_path__ + "static/media/divyansh.5171f6c1.jpg";